/*###########################################################################
// Slider content
//#########################################################################*/

import Swiper from 'swiper'
import { Autoplay } from 'swiper/modules'
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

const sliderLogoSlider = {
  config: {
    sliderLogoSlider: '.sliderLogoSlider'
  },

  elements: {},

  init() {
    const self = this

    self.elements.sliderLogoSlider = document.querySelectorAll(self.config.sliderLogoSlider)

    if (self.elements.sliderLogoSlider !== null) {
      for (let i = 0; i < self.elements.sliderLogoSlider.length; i++) {
        const sliderLogoSlider = self.elements.sliderLogoSlider[i]

        self.handleSliderLogoSlider(sliderLogoSlider)
      }
    }
  },

  handleSliderLogoSlider(slider) {
    const self = this

    const swiper = new Swiper(slider, {
			modules: [Autoplay],
			speed: 3000,
			autoplay: {
        delay: 0
      },
			watchSlidesProgress: true,
      slidesPerView: 2.6,
      spaceBetween: 20,
      loop: true,
			allowTouchMove: false,
			breakpoints: {
				480: {
					slidesPerView: 3.25,
					spaceBetween: 32,
				},
				640: {
					slidesPerView: 4.4,
					spaceBetween: 32,
				},
				800: {
					slidesPerView: 5.4,
					spaceBetween: 32,
				},
				1024: {
					slidesPerView: 6,
					spaceBetween: 42,
				},
				1280: {
					slidesPerView: 7
				},
				1440: {
					slidesPerView: 8
				},
				1600: {
					slidesPerView: 9
				}
			}
    })

		// Pause autoplay on init
		//
		swiper.slideTo(1, 100)
		swiper.autoplay.stop()

		// Handle autoplay start when scroll to cards and sliderEntry triggered
		//
		ScrollTrigger.create({
			trigger: slider.parentNode,
			start: "top +=" + (window.innerHeight / 1.25) + " middle",
			onEnter: (self) => {
				swiper.autoplay.start()
			},
			onUpdate: (self) => {
				swiper.autoplay.start()
			},
			onLeave: (self) => {
				self.kill(false, true)
			},
		});
  }
}

window.addEventListener('page-change', function() {
	setTimeout(function() {
    sliderLogoSlider.init()
  }, 500)
})

window.addEventListener('load', function () {
  sliderLogoSlider.init()
})
